<template>
<v-container >

  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
<v-card-title class="teal darken-2 white--text"><v-icon dark class="mr-4">mdi-gamepad-variant</v-icon><span class="text-capitalize">{{ $t('validation.play') }}</span>
<v-spacer/><v-btn class="white--text" @click="closeDialog()" icon><v-icon>mdi-close</v-icon></v-btn>
</v-card-title>
<v-card-text class="pt-3">


  <Gps  v-if="validationType == 'gps'" :geoloc="geoloc" :center="center" :radius="rangeValidation" :geolocating="geolocating" :typeAlert="typeAlert" :alertText="alertText" :alertGPS="alertGPS" />
  <Qrcode v-if="validationType == 'qrcode'" :qrcodeScanner="qrcodeScanner" :onDecode="onDecode"  :typeAlert="typeAlert" :alertText="alertText" :alertGPS="alertGPS"/>



  <v-btn v-if="validated" :loading="loading" block @click="submit" color="teal darken-2" dark>Valider</v-btn>
</v-card-text>
    </v-card>
  </v-dialog>
  <v-bottom-sheet v-model="s" :persistent="false">
<v-list>
  <v-subheader>Identifiez-vous afin de pouvoir jouer et gagner {{ data.value }} points.</v-subheader>
<v-divider/>
<v-list-item link :to="{name:'Signin', params: {redirect: this.$route}}">
<v-list-item-avatar>
    <v-avatar size="32px" tile>
<v-icon>mdi-login</v-icon>
  </v-avatar>
</v-list-item-avatar>
<v-list-item-title>Connexion</v-list-item-title>

</v-list-item>
<v-list-item link :to="{name:'Signup', params: {redirect: this.$route}}">
<v-list-item-avatar >
  <v-avatar size="32px" tile>
    <v-icon>mdi-account-plus</v-icon>

  </v-avatar>
</v-list-item-avatar>
<v-list-item-title>Inscription</v-list-item-title>

</v-list-item>
</v-list>
  </v-bottom-sheet>
</v-container>
</template>
<script>
//const firebase = () => import(/* webpackChunkName: 'firebase' */ '@firebase/app');
//() => import(/* webpackChunkName: 'firebase' */ '@firebase/firestore');
import firebase from '@firebase/app';

import   '@firebase/firestore';
import Gps from './gps';
import Qrcode from './qrcode';
export default {
  components: { Gps,Qrcode  },
  props: ['closeDialog', 'closeSheet','sheet', 'dialog', 'data', 'id', 'setValidationOK'],
  data: () => ({
    lastCoord: null,
    qrcodeScanner: true,
    center: null,
    radius: null,
    submitted: false,
    validated: false,
    alertGPS: false,
    geoloc: null,
    loading: false,
    watchId: null,
    rangeValidation: null,
    alertText: '',
    distTries: [],
    geolocating: false,
    typeAlert: 'warning',
    validationType: 'gps',
    validationMethod: null
  }),
  watch: {
    dialog(v) {
        if (Object.keys(this.data).includes('typeValidation')) {
          this.validationType = this.data.typeValidation;

        }
        if (!v) {
          this.qrcodeScanner = false;
        }
        this.center = [this.data.geocoord.lng, this.data.geocoord.lat];
      this.validationMethod = this['validation'+this.validationType.toUpperCase()+''];
      this.rangeValidation = this.data.range || 75;
      this.validationMethod(v);
    }
  },
  mounted() {
    if (this.$route.hash == "#validation") {
      this.dialog = true;

    }
  },
  computed: {
    s: {
      get(){
      return this.sheet;
    },
    set(v) {
      if (!v) {
        this.closeSheet();
      }
    }

  }
  },
  methods: {
    updateGeolocation(g) {

      this.geoloc = g;
    },
    distance(lat1, lon1, lat2, lon2, unit) {
  if ((lat1 == lat2) && (lon1 == lon2)) {
    return 0;
  }
  else {
    var radlat1 = Math.PI * lat1/180;
    var radlat2 = Math.PI * lat2/180;
    var theta = lon1-lon2;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit=="K") { dist = dist * 1.609344 }
    if (unit=="N") { dist = dist * 0.8684 }
    return dist;
  }
},
    validationGPS(b) {
      this.geolocating = true;
      if (b) {
        let o = {
           enableHighAccuracy: true,
           timeout: 5000,
           maximumAge: 0
        };
        //const self = this;
        this.watchId = navigator.geolocation.watchPosition((p) => {

          this.lastCoord = p.coords
          this.alertGPS  = true;
          this.typeAlert = 'warning';
          this.updateGeolocation(p.coords);
          let dist_meter = Number.parseFloat(this.distance(p.coords.latitude, p.coords.longitude, this.data.geocoord.lat, this.data.geocoord.lng, "K"))*1000;
          //self.alertText = this.distance(p.coords.latitude, p.coords.longitude, this.data.geocoord.lat, this.data.geocoord.lng, "K");
          this.distTries.push(dist_meter);
          if (dist_meter > this.rangeValidation ){
            // NOT_GOOOOOODD
            this.alertText = this.$t('validation.too_far')+' '+Number.parseFloat(dist_meter).toFixed(2)+' '+this.$t('validation.meters')+'';

          } else {
            // GOOOOOOD
            this.alertText = this.$t('validation.ok');
            navigator.geolocation.clearWatch(this.watchId);
            this.typeAlert = 'success';
            this.geolocating = false;
            this.validated = true;
          }

        }, () => {
          //console.log(e);
        }, o);

      } else {
        navigator.geolocation.clearWatch(this.watchId);
      }
      // On a besoin d'un range
    },
    validationQRCODE() {
        //console.log('validation qrcode');
    },
    validationBEACON() {

      //console.log('validation beacon');
    },
    onDecode(s) {
      let code = s.split('_');
      this.alertGPS  = false;
  if (code.length == 2) {
    if (code[0] == this.id) {
      if (code[1] == this.data.qrcodeValue) {
        this.alertText = this.$t('validation.ok');
        this.qrcodeScanner = false;
        this.typeAlert = 'success';
        this.validated = true;
      } else {
        this.alertText = this.$t('validation.qrcodeKO');
        this.typeAlert = 'warning';
        this.alertGPS  = true;

      }
    } else {
      this.alertText = this.$t('validation.qrcodeKO');
      this.typeAlert = 'warning';
      this.alertGPS  = true;


    }
  } else {
    this.alertText = this.$t('validation.qrcodeKO');
    this.typeAlert = 'warning';
    this.alertGPS  = true;


  }
},
    meta() {
      let m = {};
      //User-agentc
      m.ua = navigator.userAgent;
      //Screen
      m.scr = JSON.parse(JSON.stringify(window.screen));
      return m;
    },
    submit() {
      this.loading = true;
      const firestore = firebase.firestore();
      let l = null;
      if (this.validationType == "gps") {
        l = {lat: this.lastCoord.latitude, lng: this.lastCoord.longitude};
      }
      let v = {
        point: this.id,
        name: this.data.name_fr,
        geoloc: l,
        metadata: this.meta(),
        value: this.data.value || 2,
        type: this.validationType,
        created: (new Date()).toUTCString(),
        player: this.$store.getters.user.data.uid
      };
      firestore.collection("validations").doc().set(v).then(() => {
        this.$store.dispatch('addValidation', v);
        this.loading = false;
        this.setValidationOK();
        this.closeDialog();
        this.submitted = true;
        // On va ajouter en local puis modifier l'état du bouton
        // On va mettre à jour les score du joueur
      }).catch((e)=> {
        this.loading = false;
        alert(e.message);
      })
        // on va envoyer l'identifiant du POI, la date de validation, les points gagnés, l'identifiant du joueur, son IP
    }
  }
}

</script>
